import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ErrorFilter, stopSuppressingErrors, suppressErrors } from "../slices/errorSuppressionSlice";

interface RtkApi {
  reducerPath: string;
  endpoints: Record<string, unknown>;
}

type Endpoint<T extends RtkApi> = string & keyof T["endpoints"];
type RemainingErrorFilter = Omit<ErrorFilter, "apiName" | "endpointName">;

export const useSuppressRtkQueryErrors = <T extends RtkApi>(api: T, endpoint: Endpoint<T>, filter?: RemainingErrorFilter) => {
  const dispatch = useDispatch();
  useEffect(
    () => {
      let errorFilter: ErrorFilter = { apiName: api.reducerPath, endpointName: endpoint };
      if (filter) errorFilter = { ...filter, ...errorFilter };
      dispatch(suppressErrors(errorFilter));

      return () => { // cleanup function removes error filter
        dispatch(stopSuppressingErrors(errorFilter));
      };
    },
    [api.reducerPath, dispatch, endpoint, filter],
  );
};
